/**
 * Badass Crew PDP — free multi-select up to Buy N, mini row, float tip
 */
(function () {
  'use strict';

  function formatMoney(cents, moneyFormat) {
    cents = Math.round(Number(cents) || 0);
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents, moneyFormat || '${{amount}}');
      } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function rootUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root.slice(0, -1) : root;
  }

  function crewSizedUrl(url, width) {
    if (!url) return '';
    var u = String(url);
    var w = parseInt(width, 10) || 0;
    if (!w) return u;
    if (/([?&])width=\d+/i.test(u)) return u.replace(/([?&])width=\d+/i, '$1width=' + w);
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }

  function mediaFromProductJs(productData) {
    var images = productData && productData.images;
    if (!images || !images.length) return [];
    var out = [];
    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      var src = typeof img === 'string' ? img : (img && (img.src || img));
      if (!src) continue;
      out.push({ full: crewSizedUrl(src, 900), thumb: crewSizedUrl(src, 140) });
    }
    return out;
  }

  function parseMedia(btn) {
    try {
      var raw = btn.getAttribute('data-media');
      if (!raw) return [];
      var list = JSON.parse(raw);
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function pickKey(btn, rowId) {
    return String(rowId || '') + '|' + String(btn.dataset.variantId || '');
  }

  function readBundleConfig(root) {
    var el = root.querySelector('[data-crew-bundle-config]');
    if (!el) return { bundleVariants: {}, labels: {} };
    try {
      var parsed = JSON.parse(el.textContent || '{}');
      return {
        bundleVariants: parsed.bundleVariants || {},
        labels: parsed.labels || parsed.bundleLabels || {}
      };
    } catch (e) {
      return { bundleVariants: {}, labels: {} };
    }
  }

  function getBundleLabel(card, size, config) {
    var labels = (config && config.labels) || {};
    var fromConfig = labels[String(size)];
    if (fromConfig) return fromConfig;
    if (card && card.dataset.label) {
      var packTitle = String(card.dataset.label || '').trim();
      if (packTitle && packTitle.toLowerCase() !== 'buy') return packTitle;
    }
    return 'BadAss ' + size + '-Candle Bundle';
  }

  function getBundleDisplayTag(card, size) {
    if (card) {
      var labelEl = card.querySelector('.badass-crew__bundle-label');
      if (labelEl) {
        var text = labelEl.textContent.trim();
        if (text) return text;
      }
    }
    return 'Buy ' + size;
  }

  function getBundleVariantId(root, size, config) {
    var key = String(size);
    var card = root.querySelector('[data-crew-bundle][data-size="' + key + '"]');
    var fromCard =
      (card && (card.getAttribute('data-bundle-variant-id') || card.getAttribute('data-variant-id'))) || '';
    if (fromCard) return String(fromCard);
    var variants = (config && config.bundleVariants) || {};
    var fromConfig = variants[key];
    if (fromConfig != null && fromConfig !== '') return String(fromConfig);
    return null;
  }

  function productMatchesBundleSize(title, size) {
    var text = String(title || '').toLowerCase();
    var sz = String(size);
    var patterns = {
      '2': ['2-candle', '2 candle', '2-pack', '2 pack', 'duo', 'two'],
      '3': ['3-candle', '3 candle', '3-pack', '3 pack', 'trio', 'three'],
      '4': ['4-candle', '4 candle', '4-pack', '4 pack', 'quad', 'four'],
      '6': ['6-candle', '6 candle', '6-pack', '6 pack', 'six']
    };
    if ((patterns[sz] || []).some(function (p) {
      return text.indexOf(p) > -1;
    })) {
      return true;
    }
    return (text.indexOf('set') > -1 || text.indexOf('bundle') > -1) &&
      new RegExp('(^|[^0-9])' + sz + '([^0-9]|$)').test(text);
  }

  function applyBundleCardPricing(card, priceCents, compareCents, moneyFormat) {
    if (!card) return;
    var size = parseInt(card.getAttribute('data-size'), 10) || 1;
    var price = Math.round(Number(priceCents) || 0);
    var compare = Math.round(Number(compareCents) || 0);
    if (compare < price) compare = price;

    card.setAttribute('data-price', String(price));
    card.setAttribute('data-compare', String(compare));

    var priceEl = card.querySelector('.badass-crew__price');
    var pricesWrap = card.querySelector('.badass-crew__bundle-prices');
    var subEl = card.querySelector('.badass-crew__bundle-sub');
    var badgeEl = card.querySelector('.badass-crew__bundle-badge');

    if (priceEl) priceEl.textContent = formatMoney(price, moneyFormat);

    if (pricesWrap) {
      var compareEl = pricesWrap.querySelector('.badass-crew__compare');
      if (compare > price) {
        if (!compareEl) {
          compareEl = document.createElement('span');
          compareEl.className = 'badass-crew__compare';
          pricesWrap.appendChild(compareEl);
        }
        compareEl.textContent = formatMoney(compare, moneyFormat);
      } else if (compareEl) {
        compareEl.remove();
      }
    }

    if (subEl) {
      if (size > 1 && price > 0) {
        subEl.textContent = formatMoney(Math.round(price / size), moneyFormat) + ' each';
      } else if (size <= 1) {
        subEl.textContent = '1 candle';
      }
    }

    var savePct = compare > price && compare > 0 ? Math.round((1 - price / compare) * 100) : 0;
    if (savePct > 0) {
      if (!badgeEl) {
        badgeEl = document.createElement('span');
        badgeEl.className = 'badass-crew__bundle-badge';
        var main = card.querySelector('.badass-crew__bundle-main');
        if (main) card.insertBefore(badgeEl, main);
        else card.appendChild(badgeEl);
      }
      badgeEl.textContent = 'Save ' + savePct + '%';
    } else if (badgeEl) {
      badgeEl.remove();
    }
  }

  function fetchProductByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    return fetch(rootUrl() + '/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) return null;
      return res.json();
    }).catch(function () {
      return null;
    });
  }

  function syncBundleCardFromProduct(card, productData, moneyFormat, unitRetailCents) {
    if (!card || !productData) return;
    var size = parseInt(card.getAttribute('data-size'), 10) || 1;
    var wantId = card.getAttribute('data-bundle-variant-id') || card.getAttribute('data-variant-id');
    var variants = productData.variants || [];
    var variant =
      (wantId &&
        variants.filter(function (v) {
          return String(v.id) === String(wantId);
        })[0]) ||
      variants.filter(function (v) {
        return v.available;
      })[0] ||
      variants[0];
    if (!variant) return;
    var price = variant.price;
    var compare = variant.compare_at_price || 0;
    if ((!compare || compare <= price) && size > 1 && unitRetailCents > 0) {
      var retailTotal = Math.round(unitRetailCents * size);
      if (retailTotal > price) compare = retailTotal;
    }
    if (!compare || compare < price) compare = price;
    applyBundleCardPricing(card, price, compare, moneyFormat);
  }

  function syncPackPricesFromShopify(root, moneyFormat) {
    var unitRetail = 0;
    var firstCandle = root.querySelector('[data-crew-candle][data-price]');
    if (firstCandle) {
      unitRetail = parseInt(firstCandle.getAttribute('data-price'), 10) || 0;
    }
    if (!unitRetail) {
      try {
        var catalogEl = root.querySelector('[data-crew-scent-catalog]');
        var catalog = catalogEl ? JSON.parse(catalogEl.textContent || '[]') : [];
        if (Array.isArray(catalog) && catalog[0] && catalog[0].price) {
          unitRetail = parseInt(catalog[0].price, 10) || 0;
        }
      } catch (e) {}
    }
    if (!unitRetail && root.dataset.unitPrice) {
      unitRetail = parseInt(root.dataset.unitPrice, 10) || 0;
    }

    var cards = root.querySelectorAll('[data-crew-bundle][data-pack-handle]');
    var tasks = [];
    cards.forEach(function (card) {
      var handle = card.getAttribute('data-pack-handle');
      if (!handle) return;
      tasks.push(
        fetchProductByHandle(handle).then(function (productData) {
          syncBundleCardFromProduct(card, productData, moneyFormat, unitRetail);
        })
      );
    });
    return Promise.all(tasks);
  }

  function resolveBundleVariant(root, size, config, moneyFormat) {
    var existing = getBundleVariantId(root, size, config);
    if (existing) return Promise.resolve(existing);
    if (parseInt(size, 10) <= 1) return Promise.resolve(null);

    var labels = (config && config.labels) || {};
    var queries = [
      labels[String(size)] || ('BadAss ' + size + '-Candle Bundle'),
      'luxury scented candle ' + size + ' set',
      size + ' candle set',
      size + '-candle bundle'
    ];
    var i = 0;
    var card = root.querySelector('[data-crew-bundle][data-size="' + size + '"]');

    function tryNext() {
      if (i >= queries.length) return Promise.resolve(null);
      var query = queries[i++];
      return fetch(
        rootUrl() +
          '/search/suggest.json?q=' +
          encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=10',
        { credentials: 'same-origin' }
      )
        .then(function (res) {
          if (!res.ok) return tryNext();
          return res.json().then(function (searchData) {
            var results =
              (searchData.resources &&
                searchData.resources.results &&
                searchData.resources.results.products) ||
              [];
            var match =
              results.filter(function (item) {
                return productMatchesBundleSize(item.title, size);
              })[0] || results[0];
            if (!match || !match.handle) return tryNext();
            return fetchProductByHandle(match.handle).then(function (productData) {
              if (!productData) return tryNext();
              var variants = productData.variants || [];
              var variant =
                variants.filter(function (v) {
                  return v.available;
                })[0] || variants[0];
              if (!variant || !variant.id) return tryNext();
              config.bundleVariants = config.bundleVariants || {};
              config.bundleVariants[String(size)] = variant.id;
                if (card) {
                  card.setAttribute('data-bundle-variant-id', String(variant.id));
                  card.setAttribute('data-variant-id', String(variant.id));
                  card.setAttribute('data-pack-handle', match.handle);
                  var unitRetail = parseInt(root.dataset.unitPrice, 10) || 0;
                  syncBundleCardFromProduct(card, productData, moneyFormat, unitRetail);
                }
              if (!labels[String(size)] && productData.title) {
                config.labels = config.labels || {};
                config.labels[String(size)] = productData.title;
              }
              return String(variant.id);
            });
          });
        })
        .catch(function () {
          return tryNext();
        });
    }

    return tryNext();
  }

  function normalizeCartProperties(props) {
    if (!props) return {};
    if (Array.isArray(props)) {
      var o = {};
      props.forEach(function (p) {
        if (p && p.name != null) o[String(p.name)] = p.value != null ? String(p.value) : '';
      });
      return o;
    }
    var out = {};
    Object.keys(props).forEach(function (k) {
      out[String(k)] = String(props[k]);
    });
    return out;
  }

  function bundlePropertySignature(propsObj) {
    var size = String(propsObj['Bundle Size'] || '');
    var parts = [size];
    var i;
    for (i = 1; i <= 6; i++) {
      var key = 'Scent ' + i;
      if (propsObj[key] != null && propsObj[key] !== '') parts.push(String(propsObj[key]));
    }
    return parts.join('\u0001');
  }

  function compareBundleProperties(cartItem, newBundleItem) {
    if (!cartItem || !newBundleItem) return false;
    var vid = parseInt(cartItem.variant_id, 10) || cartItem.variant_id;
    if (vid !== parseInt(newBundleItem.id, 10)) return false;
    var a = normalizeCartProperties(cartItem.properties);
    var b = newBundleItem.properties || {};
    if (!a.Bundle || !a['Bundle Size'] || !b.Bundle || !b['Bundle Size']) return false;
    return bundlePropertySignature(a) === bundlePropertySignature(b);
  }

  function cartPageUrl() {
    if (window.routes && window.routes.cart_url) return window.routes.cart_url;
    return rootUrl() + '/cart';
  }

  function checkoutUrl() {
    if (window.routes && window.routes.checkout_url) return window.routes.checkout_url;
    return rootUrl() + '/checkout';
  }

  var cartCache = null;
  var cartFetchInFlight = null;
  var cartFetchGen = 0;

  function setCartCache(cart) {
    if (cart && Array.isArray(cart.items)) cartCache = cart;
    return cart;
  }

  function fetchCartJson(force) {
    if (!force && cartCache) return Promise.resolve(cartCache);
    if (!force && cartFetchInFlight) return cartFetchInFlight;

    var gen = ++cartFetchGen;
    var req = fetch(rootUrl() + '/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' }
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (gen !== cartFetchGen) {
          return cartCache || cart;
        }
        setCartCache(cart);
        if (cartFetchInFlight === req) cartFetchInFlight = null;
        return cartCache;
      })
      .catch(function (err) {
        if (cartFetchInFlight === req) cartFetchInFlight = null;
        throw err;
      });

    cartFetchInFlight = req;
    return req;
  }

  function invalidateCartCache() {
    cartCache = null;
    cartFetchGen += 1;
  }

  function cartUpdateUrl() {
    return (window.routes && window.routes.cart_update_url) || rootUrl() + '/cart/update.js';
  }

  function cartAddUrl() {
    return rootUrl() + '/cart/add.js';
  }

  function dispatchCartUpdated(data) {
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { source: 'crew-pdp', resource: data, skipCartAddedModal: true }
      })
    );
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'crew-pdp',
        cartData: data,
        skipCartAddedModal: true
      });
    }
  }

  function isCartBundleLine(item) {
    var props = normalizeCartProperties(item && item.properties);
    return !!(props.Bundle && props['Bundle Size']);
  }

  function cartLineMatchesPlannedItem(cartLine, plannedItem) {
    if (!cartLine || !plannedItem) return false;
    if (isCartBundleLine(cartLine)) return compareBundleProperties(cartLine, plannedItem);
    return (
      String(cartLine.variant_id) === String(plannedItem.id) &&
      (!plannedItem.properties || !Object.keys(plannedItem.properties).length)
    );
  }

  function addCartItems(items) {
    invalidateCartCache();
    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'Could not add to cart.');
        dispatchCartUpdated(data);
        invalidateCartCache();
        return fetchCartJson(true);
      });
    });
  }

  function updateCartLines(updates) {
    if (!updates || !Object.keys(updates).length) {
      return fetchCartJson(true);
    }
    invalidateCartCache();
    return fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'Could not update cart.');
        dispatchCartUpdated(data);
        invalidateCartCache();
        return fetchCartJson(true);
      });
    });
  }

  function buildBundleProperties(size, label, scents, compareCents, priceCents) {
    var props = {
      Bundle: 'Custom Bundle',
      'Bundle Size': String(size),
      'Bundle Label': label,
      '_Crew PDP': 'landing'
    };
    scents.forEach(function (scent, idx) {
      var n = idx + 1;
      props['Scent ' + n] = scent.title || 'Scent ' + n;
      var scentImg = scent.thumb || scent.image || '';
      if (scentImg) props['_Scent ' + n + ' Image'] = String(scentImg);
      if (scent.handle) props['_Scent ' + n + ' Handle'] = String(scent.handle);
    });
    if (Number(compareCents) > Number(priceCents)) {
      props['_Retail Total'] = String(compareCents);
    }
    return props;
  }

  function isCrewLandingLine(line) {
    var props = normalizeCartProperties(line && line.properties);
    return props['_Crew PDP'] === 'landing';
  }

  function crewLineSizeKey(properties) {
    var props = normalizeCartProperties(properties);
    var isMini = /mini/i.test(props['Bundle Label'] || '');
    return (isMini ? 'mini:' : 'main:') + String(props['Bundle Size'] || '');
  }

  function selectionSignature(items) {
    return items
      .map(function (item) {
        return String(item.id) + '\u0002' + bundlePropertySignature(item.properties || {});
      })
      .join('\u0001');
  }

  function init(root) {
    if (!root || root.dataset.crewReady) return;
    root.dataset.crewReady = '1';

    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var ctaLabel = root.dataset.ctaLabel || 'Continue to Checkout';
    var pickPlaceholder = root.dataset.pickPlaceholder || 'Pick a scent';

    var mainImg = root.querySelector('[data-crew-main-img]');
    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-crew-bundle]'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-crew-row]:not([data-crew-mini-row])'));
    var allMainCandles = Array.prototype.slice.call(root.querySelectorAll('[data-crew-candle]'));
    var scentCatalog = [];
    try {
      var catalogEl = root.querySelector('[data-crew-scent-catalog]');
      if (catalogEl) {
        var parsedCatalog = JSON.parse(catalogEl.textContent || '[]');
        if (Array.isArray(parsedCatalog)) scentCatalog = parsedCatalog;
      }
    } catch (err) {
      scentCatalog = [];
    }
    var openPickerBtn = root.querySelector('[data-crew-open-picker]');
    var mini = root.querySelector('[data-crew-mini]');
    var miniRow = root.querySelector('[data-crew-mini-row]');
    var miniCandles = miniRow
      ? Array.prototype.slice.call(miniRow.querySelectorAll('[data-crew-mini-candle]'))
      : [];
    var ctas = Array.prototype.slice.call(root.querySelectorAll('[data-crew-cta]'));
    var hint = root.querySelector('[data-crew-hint]');
    var ctaThumb = root.querySelector('[data-crew-cta-thumb]');
    var ctaTitle = root.querySelector('[data-crew-cta-title]');
    var ctaPrice = root.querySelector('[data-crew-cta-price]');
    var ctaCompare = root.querySelector('[data-crew-cta-compare]');
    var ctaBundle = root.querySelector('[data-crew-cta-bundle]');
    var ctaPicks = root.querySelector('[data-crew-cta-picks]');
    var selectCount = root.querySelector('[data-crew-select-count]');
    var selectedList = root.querySelector('[data-crew-selected-list]');
    var floatTip = root.querySelector('[data-crew-float-tip]');
    var peek = root.querySelector('[data-crew-peek]');
    var peekImg = root.querySelector('[data-crew-peek-img]');
    var peekTitle = root.querySelector('[data-crew-peek-title]');
    var peekThumbs = root.querySelector('[data-crew-peek-thumbs]');
    var peekPrice = root.querySelector('[data-crew-peek-price]');
    var peekCompare = root.querySelector('[data-crew-peek-compare]');
    var peekMeta = root.querySelector('[data-crew-peek-meta]');
    var peekDesc = root.querySelector('[data-crew-peek-desc]');
    var peekLink = root.querySelector('[data-crew-peek-link]');
    var accordionBody = root.querySelector('[data-crew-accordion-body]');
    var defaultDescriptionHtml = accordionBody ? accordionBody.innerHTML : '';
    var descriptionCatalog = {};
    root.querySelectorAll('[data-crew-desc-store] [data-crew-desc]').forEach(function (el) {
      var handle = el.getAttribute('data-crew-desc');
      if (handle && !descriptionCatalog[handle]) descriptionCatalog[handle] = el.innerHTML;
    });
    var ctaBar = root.querySelector('[data-crew-cta-bar]');
    var selectHead = root.querySelector('.badass-crew__select-head');
    var headingEl = root.querySelector('.badass-crew__title');
    var defaultCtaTitle = (headingEl && headingEl.textContent.trim()) || 'BadAss Crew';
    var defaultCtaThumb = ctaThumb ? ctaThumb.getAttribute('src') || '' : '';
    if (ctaTitle && (!ctaTitle.textContent.trim() || ctaTitle.textContent.trim() === 'Buy')) {
      ctaTitle.textContent = defaultCtaTitle;
    }
    var EYE_SVG =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
    var productInfoCache = {};

    /* { key, variantId, title, image, thumb, media, rowId, handle, price, compare, vendor, type, url } */
    var selected = [];
    var miniSelected = [];

    function closePeek() {
      if (!peek) return;
      peek.hidden = true;
      peek.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function fetchProductData(handle) {
      if (!handle) return Promise.reject(new Error('No handle'));
      if (productInfoCache[handle]) return Promise.resolve(productInfoCache[handle]);
      return fetch(rootUrl() + '/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin'
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Product not found');
          return res.json();
        })
        .then(function (productData) {
          productInfoCache[handle] = productData;
          return productData;
        });
    }

    function fillPeekDetails(pick, productData) {
      var priceCents = pick.price != null ? pick.price : null;
      var compareCents = pick.compare != null ? pick.compare : 0;
      var vendor = pick.vendor || '';
      var productType = pick.type || '';
      var descHtml = pick.descriptionHtml || '';
      var url = pick.url || '';

      if (productData) {
        vendor = productData.vendor || vendor;
        productType = productData.type || productType;
        descHtml = productData.description || descHtml;
        if (productData.handle) {
          url = rootUrl() + '/products/' + productData.handle;
        }
        var variants = productData.variants || [];
        var matched =
          (pick.variantId &&
            variants.filter(function (v) {
              return String(v.id) === String(pick.variantId);
            })[0]) ||
          variants[0];
        if (matched) {
          priceCents = matched.price;
          compareCents = matched.compare_at_price || 0;
        } else if (productData.price != null) {
          priceCents = productData.price;
          compareCents = productData.compare_at_price || 0;
        }
      }

      if (url && url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
        url = '/products/' + url;
      }

      if (peekPrice) {
        if (priceCents != null && priceCents !== '') {
          peekPrice.textContent = formatMoney(priceCents, moneyFormat);
          peekPrice.hidden = false;
        } else {
          peekPrice.textContent = '';
          peekPrice.hidden = true;
        }
      }
      if (peekCompare) {
        if (compareCents && Number(compareCents) > Number(priceCents || 0)) {
          peekCompare.textContent = formatMoney(compareCents, moneyFormat);
          peekCompare.hidden = false;
        } else {
          peekCompare.textContent = '';
          peekCompare.hidden = true;
        }
      }
      if (peekMeta) {
        var bits = [];
        if (vendor) bits.push('<span><strong>Vendor:</strong> ' + escapeHtml(vendor) + '</span>');
        if (productType) bits.push('<span><strong>Type:</strong> ' + escapeHtml(productType) + '</span>');
        if (bits.length) {
          peekMeta.innerHTML = bits.join('');
          peekMeta.hidden = false;
        } else {
          peekMeta.innerHTML = '';
          peekMeta.hidden = true;
        }
      }
      if (peekDesc) {
        if (descHtml) {
          peekDesc.innerHTML = descHtml;
          peekDesc.hidden = false;
        } else {
          peekDesc.innerHTML = '<p>No product description available.</p>';
          peekDesc.hidden = false;
        }
      }
      if (peekLink) {
        if (url) {
          peekLink.href = url;
          peekLink.hidden = false;
        } else {
          peekLink.removeAttribute('href');
          peekLink.hidden = true;
        }
      }
    }

    function openPeek(pick) {
      if (!peek || !pick) return;
      var media = Array.isArray(pick.media) ? pick.media : [];
      var mainSrc = pick.image || pick.thumb || (media[0] && media[0].full) || '';
      if (peekTitle) peekTitle.textContent = pick.title || 'Candle';
      if (peekImg) {
        peekImg.src = mainSrc || '';
        peekImg.alt = pick.title || '';
      }
      if (peekThumbs) {
        if (media.length > 1) {
          peekThumbs.hidden = false;
          peekThumbs.innerHTML = media
            .map(function (m, i) {
              var src = m.thumb || m.full || '';
              var full = m.full || m.thumb || '';
              return (
                '<button type="button" class="badass-crew__peek-thumb' +
                (i === 0 ? ' is-active' : '') +
                '" data-full="' +
                escapeHtml(full) +
                '" aria-label="View image ' +
                (i + 1) +
                '">' +
                (src ? '<img src="' + escapeHtml(src) + '" alt="" width="56" height="56">' : '') +
                '</button>'
              );
            })
            .join('');
        } else {
          peekThumbs.hidden = true;
          peekThumbs.innerHTML = '';
        }
      }

      fillPeekDetails(pick, null);
      if (peekDesc) {
        peekDesc.innerHTML = '<p class="badass-crew__peek-loading">Loading details…</p>';
      }

      peek.hidden = false;
      peek.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      var handle = pick.handle;
      if (!handle) {
        fillPeekDetails(pick, null);
        return;
      }
      fetchProductData(handle)
        .then(function (productData) {
          if (productData.title && peekTitle) peekTitle.textContent = productData.title;
          var fetchedMedia = mediaFromProductJs(productData);
          if (fetchedMedia.length && peekImg) {
            if (!mainSrc) peekImg.src = fetchedMedia[0].full || productData.featured_image || '';
            if (peekThumbs && fetchedMedia.length > 1) {
              peekThumbs.hidden = false;
              peekThumbs.innerHTML = fetchedMedia
                .map(function (m, i) {
                  var src = m.thumb || m.full || '';
                  var full = m.full || m.thumb || '';
                  return (
                    '<button type="button" class="badass-crew__peek-thumb' +
                    (i === 0 ? ' is-active' : '') +
                    '" data-full="' +
                    escapeHtml(full) +
                    '" aria-label="View image ' +
                    (i + 1) +
                    '">' +
                    (src ? '<img src="' + escapeHtml(src) + '" alt="" width="56" height="56">' : '') +
                    '</button>'
                  );
                })
                .join('');
            }
          } else if (productData.featured_image && peekImg && !mainSrc) {
            peekImg.src = productData.featured_image;
          }
          fillPeekDetails(pick, productData);
        })
        .catch(function () {
          fillPeekDetails(pick, null);
        });
    }

    function syncDescription(pick) {
      if (!accordionBody) return;

      function render(html) {
        accordionBody.innerHTML =
          html && String(html).trim()
            ? html
            : defaultDescriptionHtml || '<p class="badass-crew__desc-placeholder">Select a candle to view its description.</p>';
      }

      if (!pick || !pick.handle) {
        render('');
        return;
      }

      if (descriptionCatalog[pick.handle]) {
        render(descriptionCatalog[pick.handle]);
        return;
      }

      if (productInfoCache[pick.handle]) {
        render(productInfoCache[pick.handle].description);
        return;
      }

      accordionBody.innerHTML = '<p class="badass-crew__peek-loading">Loading description…</p>';
      fetchProductData(pick.handle)
        .then(function (productData) {
          render(productData.description);
        })
        .catch(function () {
          render('');
        });
    }

    function hydratePickMedia(pick) {
      if (!pick || !pick.handle) return;
      fetchProductData(pick.handle)
        .then(function (productData) {
          var fetched = mediaFromProductJs(productData);
          if (!fetched.length) return;
          pick.media = fetched;
          pick.image = fetched[0].full || pick.image;
          pick.thumb = fetched[0].thumb || pick.thumb;
          var latest = selected.length ? selected[selected.length - 1] : null;
          if (latest && latest.handle === pick.handle) {
            updateGallery(fetched, pick.title || '');
          }
        })
        .catch(function () {});
    }

    function previewProduct(pick) {
      if (!pick) {
        syncProductPreview();
        return;
      }
      updateGallery(mediaForPick(pick), pick.title || '');
      syncDescription(pick);
      hydratePickMedia(pick);
    }

    function mediaForPick(pick) {
      if (!pick) return [];
      var media = Array.isArray(pick.media) && pick.media.length ? pick.media : [];
      if (!media.length) {
        var thumb = pick.thumb || pick.image || '';
        var full = pick.image || (thumb ? crewSizedUrl(thumb, 900) : '');
        if (full || thumb) media = [{ full: full || thumb, thumb: thumb || full }];
      }
      return media;
    }

    function syncProductPreview() {
      var latest = selected.length ? selected[selected.length - 1] : null;
      if (!latest) {
        restoreDefaultGallery();
        syncDescription(null);
        return;
      }
      updateGallery(mediaForPick(latest), latest.title || '');
      syncDescription(latest);
      hydratePickMedia(latest);
    }

    function activeBundle() {
      return root.querySelector('[data-crew-bundle].is-selected');
    }

    function bundleSize() {
      var b = activeBundle();
      return b ? parseInt(b.dataset.size, 10) || 1 : 1;
    }

    function miniSize() {
      /* Mini Squad addon: always single-select (1 scent) */
      return 1;
    }

    function setHint(msg) {
      if (hint) hint.textContent = msg || '';
      root.classList.toggle('has-cta-hint', !!(msg && String(msg).trim()));
    }

    function setCtasDisabled(disabled) {
      ctas.forEach(function (btn) {
        btn.disabled = !!disabled;
      });
    }

    function findByKey(list, key) {
      return list.findIndex(function (s) {
        return s.key === key;
      });
    }

    function pickFromBtn(btn, rowId) {
      var thumb = btn.dataset.thumb || btn.dataset.image || '';
      var image = btn.dataset.image ? crewSizedUrl(btn.dataset.image, 900) : thumb ? crewSizedUrl(thumb, 900) : '';
      return {
        key: pickKey(btn, rowId),
        variantId: btn.dataset.variantId,
        title: btn.dataset.title || '',
        handle: btn.dataset.handle || '',
        image: image,
        thumb: thumb || image,
        media: parseMedia(btn),
        price: btn.dataset.price != null ? parseInt(btn.dataset.price, 10) : null,
        compare: btn.dataset.compare != null ? parseInt(btn.dataset.compare, 10) : 0,
        vendor: btn.dataset.vendor || '',
        type: btn.dataset.type || '',
        url: btn.dataset.url || '',
        rowId: rowId || ''
      };
    }

    function syncCta() {
      var b = activeBundle();
      if (!b || !ctas.length) return;
      var size = parseInt(b.dataset.size, 10) || 1;
      var total = parseInt(b.dataset.price, 10) || 0;
      var compare = parseInt(b.dataset.compare, 10) || 0;
      if (mini && mini.classList.contains('is-selected')) {
        total += parseInt(mini.dataset.price, 10) || 0;
        compare += parseInt(mini.dataset.compare, 10) || parseInt(mini.dataset.price, 10) || 0;
      }

      var labelEl = b.querySelector('.badass-crew__bundle-label');
      var bundleName = ((labelEl && labelEl.textContent) || 'Buy ' + size).trim();
      var latest = selected.length ? selected[selected.length - 1] : null;
      var title =
        latest && latest.title
          ? latest.title
          : defaultCtaTitle || bundleName;

      if (ctaTitle) ctaTitle.textContent = title;

      if (ctaThumb) {
        var thumbSrc = (latest && (latest.thumb || latest.image)) || defaultCtaThumb;
        if (thumbSrc) {
          ctaThumb.src = thumbSrc;
          ctaThumb.hidden = false;
        } else {
          ctaThumb.hidden = true;
        }
      }

      if (ctaPrice) ctaPrice.textContent = formatMoney(total, moneyFormat);
      if (ctaCompare) {
        if (compare > total) {
          ctaCompare.textContent = formatMoney(compare, moneyFormat);
          ctaCompare.hidden = false;
        } else {
          ctaCompare.textContent = '';
          ctaCompare.hidden = true;
        }
      }

      if (ctaBundle) ctaBundle.textContent = 'Buy ' + size;
      if (ctaPicks) {
        ctaPicks.textContent = selected.length + '/' + size + ' selected';
      }
      /* Mobile: show pick progress under title when empty/partial */
      if (ctaTitle && window.matchMedia('(max-width: 749px)').matches && selected.length < size) {
        ctaTitle.textContent =
          (latest && latest.title ? latest.title : defaultCtaTitle) +
          ' · ' +
          selected.length +
          '/' +
          size;
      }

      ctas.forEach(function (btn) {
        if (btn.classList.contains('badass-crew__cta--inline')) {
          btn.textContent = ctaLabel + ' - ' + formatMoney(total, moneyFormat);
        } else {
          btn.textContent = ctaLabel;
        }
      });
    }

    function syncCandleClasses() {
      miniCandles.forEach(function (c) {
        var on = findByKey(miniSelected, pickKey(c, 'mini')) > -1;
        c.classList.toggle('is-selected', on);
      });
    }

    function syncSelectedUI() {
      var size = bundleSize();
      trimToSize(selected, size);

      if (selectCount) {
        selectCount.textContent = selected.length ? ' (' + selected.length + '/' + size + ')' : '';
      }

      if (openPickerBtn) {
        var label = root.dataset.selectLabel || 'Select your candles';
        if (selected.length >= size && size > 0) {
          openPickerBtn.textContent = 'Change scents (' + selected.length + '/' + size + ')';
        } else if (selected.length) {
          openPickerBtn.textContent = 'Continue selecting (' + selected.length + '/' + size + ')';
        } else {
          openPickerBtn.textContent = label;
        }
      }

      if (selectedList) {
        if (!selected.length) {
          selectedList.innerHTML = '';
          selectedList.hidden = true;
        } else {
          selectedList.hidden = false;
          selectedList.innerHTML = selected
            .map(function (p, idx) {
              var img = p.thumb
                ? '<img src="' + escapeHtml(p.thumb) + '" alt="" width="28" height="28">'
                : '';
              return (
                '<span class="badass-crew__chip">' +
                img +
                '<span class="badass-crew__chip-name">' +
                escapeHtml(p.title) +
                '</span>' +
                '<button type="button" class="badass-crew__chip-peek" data-crew-chip-peek="' +
                idx +
                '" aria-label="View ' +
                escapeHtml(p.title) +
                '">' +
                EYE_SVG +
                '</button></span>'
              );
            })
            .join('');
        }
      }

      if (miniRow) {
        var miniName = miniRow.querySelector('[data-crew-mini-pick]');
        if (miniName) {
          var miniFallback = miniName.getAttribute('data-default') || pickPlaceholder;
          if (miniSelected.length) {
            miniName.textContent = miniSelected[miniSelected.length - 1].title;
            miniName.classList.add('is-filled');
          } else {
            miniName.textContent = miniFallback;
            miniName.classList.remove('is-filled');
          }
        }
      }

      syncCandleClasses();

      var latest = selected.length ? selected[selected.length - 1] : null;
      root.dispatchEvent(
        new CustomEvent('crew:selection-change', {
          detail: { handle: latest && latest.handle ? latest.handle : '', count: selected.length, size: size }
        })
      );
    }

    function updateGallery(media, title) {
      if (!mainImg) return;
      if (!media || !media.length) {
        if (title) mainImg.alt = title;
        return;
      }

      var first = media[0];
      var src = first.full || first;
      mainImg.src = src ? crewSizedUrl(src, 900) : '';
      mainImg.alt = title || '';
      if (mainImg.removeAttribute) mainImg.removeAttribute('srcset');
    }

    function restoreDefaultGallery() {
      if (!mainImg) return;
      var defSrc = mainImg.getAttribute('data-crew-default-src');
      var defAlt = mainImg.getAttribute('data-crew-default-alt') || '';
      if (!defSrc) return;
      mainImg.src = defSrc;
      mainImg.alt = defAlt;
      if (mainImg.removeAttribute) mainImg.removeAttribute('srcset');
    }

    function trimToSize(list, size) {
      if (list.length > size) list.splice(size);
    }

    function togglePick(list, btn, rowId, size, syncPreview) {
      var key = pickKey(btn, rowId);
      var idx = findByKey(list, key);

      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        if (list.length >= size) list.shift();
        list.push(pickFromBtn(btn, rowId));
      }

      if (syncPreview && list === selected) syncProductPreview();
    }

    /* Floating tooltip (avoids overflow clipping) */
    function hideFloatTip() {
      if (!floatTip) return;
      floatTip.hidden = true;
      floatTip.classList.remove('is-visible');
      floatTip.textContent = '';
    }

    function showFloatTip(btn) {
      if (!floatTip || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      var tip = btn.querySelector('.badass-crew__candle-tip');
      var text = (tip && tip.textContent) || btn.getAttribute('aria-label') || btn.dataset.title || '';
      if (!text) return;

      floatTip.textContent = text;
      floatTip.hidden = false;
      floatTip.classList.add('is-visible');

      var rect = btn.getBoundingClientRect();
      var tipRect = floatTip.getBoundingClientRect();
      var left = rect.left + rect.width / 2 - tipRect.width / 2;
      var top = rect.top - tipRect.height - 10;

      if (left < 8) left = 8;
      if (left + tipRect.width > window.innerWidth - 8) {
        left = window.innerWidth - tipRect.width - 8;
      }
      if (top < 8) top = rect.bottom + 10;

      floatTip.style.left = Math.round(left) + 'px';
      floatTip.style.top = Math.round(top) + 'px';
    }

    root.querySelectorAll('.badass-crew__candle').forEach(function (btn) {
      btn.addEventListener('mouseenter', function () {
        showFloatTip(btn);
      });
      btn.addEventListener('mouseleave', hideFloatTip);
      btn.addEventListener('focus', function () {
        showFloatTip(btn);
      });
      btn.addEventListener('blur', hideFloatTip);
    });
    window.addEventListener('scroll', hideFloatTip, true);

    function setupRowScrollers() {
      root.querySelectorAll('[data-crew-row-scroller]').forEach(function (scroller) {
        var track =
          scroller.querySelector('[data-crew-candles]') ||
          scroller.querySelector('[data-crew-mini-candles]');
        var nav = scroller.querySelector('.badass-crew__scroll-nav');
        var prev = scroller.querySelector('[data-crew-scroll="-1"]');
        var next = scroller.querySelector('[data-crew-scroll="1"]');
        if (!track) return;

        function update() {
          var max = track.scrollWidth - track.clientWidth;
          var scrollable = max > 8;
          scroller.classList.toggle('is-scrollable', scrollable);
          if (nav) nav.setAttribute('aria-hidden', scrollable ? 'false' : 'true');
          if (prev) {
            prev.disabled = !scrollable || track.scrollLeft <= 2;
            prev.tabIndex = scrollable ? 0 : -1;
          }
          if (next) {
            next.disabled = !scrollable || track.scrollLeft >= max - 2;
            next.tabIndex = scrollable ? 0 : -1;
          }
        }

        function scrollByDir(dir) {
          var step = Math.max(140, Math.round(track.clientWidth * 0.75));
          track.scrollBy({ left: dir * step, behavior: 'smooth' });
        }

        if (prev) {
          prev.addEventListener('click', function (e) {
            e.preventDefault();
            scrollByDir(-1);
          });
        }
        if (next) {
          next.addEventListener('click', function (e) {
            e.preventDefault();
            scrollByDir(1);
          });
        }

        track.addEventListener('scroll', update, { passive: true });
        if (typeof ResizeObserver !== 'undefined') {
          var ro = new ResizeObserver(update);
          ro.observe(track);
          ro.observe(scroller);
        } else {
          window.addEventListener('resize', update);
        }
        /* Images can change scrollWidth after load */
        track.querySelectorAll('img').forEach(function (img) {
          if (!img.complete) img.addEventListener('load', update, { once: true });
        });
        update();
        requestAnimationFrame(update);
      });
    }

    setupRowScrollers();

    /* Bundles — PDP-style popup (same vs different scents), stay on landing + crew drawer */
    var crewPickerState = {
      mode: 'mixed',
      need: 0,
      bundleSize: 0,
      selected: [],
      filter: 'all',
      products: [],
      bound: false
    };

    function getCrewPickerEls() {
      var modal = document.getElementById('badass-pdp-scent-picker');
      if (!modal) return null;
      return {
        modal: modal,
        list: modal.querySelector('[data-pdp-scent-list]'),
        counter: modal.querySelector('[data-pdp-scent-counter]'),
        hint: modal.querySelector('[data-pdp-scent-hint]'),
        addBtn: modal.querySelector('[data-pdp-scent-add]'),
        checkoutBtn: modal.querySelector('[data-pdp-scent-checkout]'),
        filters: modal.querySelectorAll('[data-pdp-scent-filter]'),
        title: modal.querySelector('.badass-pdp-scent-picker__title')
      };
    }

    function mountCrewPickerToBody() {
      var modal = document.getElementById('badass-pdp-scent-picker');
      if (!modal || !document.body) return modal;
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
      return modal;
    }

    function buildCrewScentPool() {
      return scentCatalog
        .filter(function (product) {
          return product && product.available !== false && (product.handle || product.variant_id);
        })
        .map(function (product) {
          return {
            id: product.handle || String(product.variant_id),
            title: product.title || '',
            handle: product.handle || '',
            featured_image: product.featured_image || product.thumb || product.image || '',
            image: product.image || (product.featured_image ? crewSizedUrl(product.featured_image, 900) : ''),
            thumb: product.thumb || product.featured_image || '',
            variant_id: product.variant_id ? parseInt(product.variant_id, 10) : null,
            available: product.available !== false,
            price: Number(product.price) || 0,
            compare_at_price: Number(product.compare_at_price) || Number(product.price) || 0,
            vendor: product.vendor || '',
            type: product.type || '',
            url: product.url || '',
            tags: Array.isArray(product.tags) ? product.tags : [],
            rowId: product.rowId || '',
            media: Array.isArray(product.media) ? product.media : []
          };
        });
    }

    function crewProductMatchesFilter(product, filter) {
      if (!filter || filter === 'all') return true;
      var tags = (product.tags || []).map(function (tag) {
        return String(tag).toLowerCase().trim();
      });
      var key = String(filter).toLowerCase().trim();

      function tagHit(matchers) {
        return tags.some(function (tag) {
          return matchers.some(function (m) {
            return tag === m || tag.indexOf(m) >= 0;
          });
        });
      }

      if (key === 'new-arrivals' || key === 'new arrivals' || key === 'new') {
        return tagHit(['newly launched', 'new launch', 'new arrival', 'new-arrivals', 'new']);
      }
      if (key === 'fallout scents' || key === 'fallout-scents' || key === 'fall scents' || key === 'fall scent') {
        return tagHit(['fallout scents', 'fallout scent', 'fall scents', 'fall scent']);
      }
      if (key === 'most popular') {
        return tagHit(['most popular']);
      }
      if (key === 'best selling' || key === 'best-selling') {
        return tagHit(['best selling', 'best seller', 'bestseller', 'best-seller']);
      }
      return tagHit([key]);
    }

    function crewPickerFilled() {
      return crewPickerState.selected.filter(Boolean).length;
    }

    function crewIsSelected(productId) {
      return crewPickerState.selected.some(function (item) {
        return item && String(item.id) === String(productId);
      });
    }

    function updateCrewPickerChrome() {
      var els = getCrewPickerEls();
      if (!els) return;
      var filled = crewPickerFilled();
      var need = crewPickerState.need;
      if (els.counter) els.counter.textContent = filled + ' of ' + need + ' selected';
      var complete = filled >= need;
      if (els.hint) {
        els.hint.textContent = complete
          ? 'Ready — add to cart or checkout.'
          : 'Select ' + (need - filled) + ' more scent' + (need - filled === 1 ? '' : 's') + '.';
      }
      if (els.addBtn) els.addBtn.disabled = !complete;
      if (els.checkoutBtn) els.checkoutBtn.disabled = !complete;
    }

    function renderCrewPickerList() {
      var els = getCrewPickerEls();
      if (!els || !els.list) return;
      var filled = crewPickerFilled();
      var full = filled >= crewPickerState.need;
      var filtered = crewPickerState.products.filter(function (product) {
        return crewProductMatchesFilter(product, crewPickerState.filter);
      });

      if (!filtered.length) {
        els.list.innerHTML = '<p class="badass-pdp-scent-picker__empty">No scents match this filter.</p>';
        return;
      }

      els.list.innerHTML = '';
      filtered.forEach(function (product) {
        var isOn = crewIsSelected(product.id);
        var disabled = !product.available || (full && !isOn);
        var card = document.createElement('button');
        card.type = 'button';
        card.className =
          'badass-pdp-scent-picker__card' +
          (isOn ? ' is-selected' : '') +
          (!product.available ? ' is-soldout' : '');
        card.setAttribute('role', 'listitem');
        card.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        card.disabled = disabled;

        var price = Number(product.price) || 0;
        var compare = Number(product.compare_at_price) || price;
        var priceHtml =
          compare > price
            ? '<span class="badass-pdp-scent-picker__compare">' +
              formatMoney(compare, moneyFormat) +
              '</span><span class="badass-pdp-scent-picker__price">' +
              formatMoney(price, moneyFormat) +
              '</span>'
            : '<span class="badass-pdp-scent-picker__price">' + formatMoney(price, moneyFormat) + '</span>';

        card.innerHTML =
          '<span class="badass-pdp-scent-picker__media">' +
          (product.featured_image
            ? '<img src="' + escapeHtml(product.featured_image) + '" alt="" loading="lazy" width="120" height="120">'
            : '') +
          '</span>' +
          '<span class="badass-pdp-scent-picker__meta">' +
          '<span class="badass-pdp-scent-picker__name">' +
          escapeHtml(product.title || '') +
          '</span>' +
          '<span class="badass-pdp-scent-picker__prices">' +
          priceHtml +
          '</span>' +
          '</span>' +
          (isOn ? '<span class="badass-pdp-scent-picker__check" aria-hidden="true">✓</span>' : '');

        card.addEventListener('click', function () {
          toggleCrewPickerProduct(product);
        });
        els.list.appendChild(card);
      });
    }

    function toggleCrewPickerProduct(product) {
      if (!product || !product.available) return;
      var id = String(product.id);
      var idx = crewPickerState.selected.findIndex(function (item) {
        return item && String(item.id) === id;
      });
      if (idx >= 0) {
        crewPickerState.selected[idx] = null;
        var kept = crewPickerState.selected.filter(Boolean);
        crewPickerState.selected = Array.from({ length: crewPickerState.need }, function (_, i) {
          return kept[i] || null;
        });
      } else {
        if (crewPickerFilled() >= crewPickerState.need) return;
        var emptyIdx = crewPickerState.selected.findIndex(function (item) {
          return !item;
        });
        if (emptyIdx < 0) return;
        crewPickerState.selected[emptyIdx] = product;
      }
      renderCrewPickerList();
      updateCrewPickerChrome();
    }

    function closeCrewScentPicker() {
      var els = getCrewPickerEls();
      if (!els) return;
      els.modal.setAttribute('hidden', '');
      els.modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function setCrewPickerFilter(filter) {
      crewPickerState.filter = filter || 'all';
      var els = getCrewPickerEls();
      if (els) {
        els.filters.forEach(function (btn) {
          var active = (btn.getAttribute('data-pdp-scent-filter') || '') === crewPickerState.filter;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }
      renderCrewPickerList();
    }

    function pickFromScentProduct(product, slotIndex) {
      var thumb = product.thumb || product.featured_image || '';
      var image = product.image || (thumb ? crewSizedUrl(thumb, 900) : product.featured_image || '');
      var media = Array.isArray(product.media) && product.media.length
        ? product.media
        : image || thumb
          ? [
              {
                full: image || thumb,
                thumb: thumb || image
              }
            ]
          : [];
      return {
        key: 'popup::' + (product.handle || product.id) + '::' + slotIndex,
        variantId: product.variant_id ? String(product.variant_id) : '',
        title: product.title || '',
        handle: product.handle || '',
        image: image,
        thumb: thumb || image,
        media: media,
        price: Number(product.price) || 0,
        compare: Number(product.compare_at_price) || 0,
        vendor: product.vendor || '',
        type: product.type || '',
        url: product.url || (product.handle ? '/products/' + product.handle : ''),
        rowId: product.rowId || ''
      };
    }

    function applyCrewPickerToSelection() {
      var picks = crewPickerState.selected.filter(Boolean);
      var size = crewPickerState.bundleSize || bundleSize();
      selected.length = 0;

      if (crewPickerState.mode === 'same') {
        var one = picks[0];
        if (!one) return false;
        for (var i = 0; i < size; i++) {
          selected.push(pickFromScentProduct(one, i));
        }
      } else {
        for (var j = 0; j < picks.length && j < size; j++) {
          selected.push(pickFromScentProduct(picks[j], j));
        }
      }

      lastSyncedSignature = '';
      drawerDismissed = false;
      selectionWasComplete = selected.length >= size;
      syncSelectedUI();
      syncCta();
      syncProductPreview();
      return selected.length >= size;
    }

    function finishCrewPicker(goCheckout) {
      if (crewPickerFilled() < crewPickerState.need) return;
      if (!applyCrewPickerToSelection()) {
        setHint('Could not apply your scent selection.');
        return;
      }

      var els = getCrewPickerEls();
      var activeBtn = goCheckout ? els && els.checkoutBtn : els && els.addBtn;
      if (activeBtn) activeBtn.classList.add('is-loading');
      if (els && els.addBtn) els.addBtn.disabled = true;
      if (els && els.checkoutBtn) els.checkoutBtn.disabled = true;

      runCartOp(function () {
        return syncSelectionToCart().then(function () {
          return refreshDrawerFromCart(null, { force: true });
        });
      })
        .then(function () {
          closeCrewScentPicker();
          if (goCheckout) {
            window.location.href = checkoutUrl();
            return;
          }
          if (drawerEnabled && window.BadassCrewCartDrawer) {
            window.BadassCrewCartDrawer.open();
          }
        })
        .catch(function (err) {
          setHint((err && err.message) || 'Could not add to cart.');
          updateCrewPickerChrome();
        })
        .finally(function () {
          if (activeBtn) activeBtn.classList.remove('is-loading');
        });
    }

    function bindCrewPickerOnce() {
      if (crewPickerState.bound) return;
      var els = getCrewPickerEls();
      if (!els) return;
      crewPickerState.bound = true;

      els.modal.querySelectorAll('[data-pdp-scent-close]').forEach(function (el) {
        el.addEventListener('click', closeCrewScentPicker);
      });
      els.filters.forEach(function (btn) {
        btn.addEventListener('click', function () {
          setCrewPickerFilter(btn.getAttribute('data-pdp-scent-filter') || 'all');
        });
      });
      if (els.addBtn) {
        els.addBtn.addEventListener('click', function () {
          finishCrewPicker(false);
        });
      }
      if (els.checkoutBtn) {
        els.checkoutBtn.addEventListener('click', function () {
          finishCrewPicker(true);
        });
      }
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (!els.modal || els.modal.hasAttribute('hidden')) return;
        closeCrewScentPicker();
      });
    }

    function openCrewScentPicker(options) {
      var opts = options || {};
      var els = getCrewPickerEls();
      if (!els) {
        setHint('Scent picker is unavailable.');
        return;
      }
      if (!scentCatalog.length) {
        setHint('No scents are configured. Add candle row collections in the theme editor.');
        return;
      }
      mountCrewPickerToBody();
      crewPickerState.mode = opts.mode === 'same' ? 'same' : 'mixed';
      crewPickerState.bundleSize = opts.bundleSize || bundleSize();
      crewPickerState.need = opts.mode === 'same' ? 1 : crewPickerState.bundleSize;
      crewPickerState.products = buildCrewScentPool();
      crewPickerState.selected = Array.from({ length: crewPickerState.need }, function () {
        return null;
      });

      /* Prefill from current page selection when editing */
      if (crewPickerState.mode === 'mixed' && selected.length) {
        for (var i = 0; i < selected.length && i < crewPickerState.need; i++) {
          var match = crewPickerState.products.find(function (p) {
            return p.handle && selected[i].handle && p.handle === selected[i].handle;
          });
          if (match) crewPickerState.selected[i] = match;
        }
      } else if (crewPickerState.mode === 'same' && selected.length) {
        var sameMatch = crewPickerState.products.find(function (p) {
          return p.handle && selected[0].handle && p.handle === selected[0].handle;
        });
        if (sameMatch) crewPickerState.selected[0] = sameMatch;
      }

      crewPickerState.filter = 'all';

      if (els.title) {
        els.title.textContent =
          crewPickerState.mode === 'same'
            ? 'Pick one scent for all candles'
            : crewPickerState.need === 1
              ? 'Pick your scent'
              : 'Pick your scents';
      }

      bindCrewPickerOnce();
      setCrewPickerFilter('all');
      updateCrewPickerChrome();
      els.modal.removeAttribute('hidden');
      els.modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function openCrewBundleChoiceModal(quantity) {
      var size = parseInt(quantity, 10) || 1;
      if (size <= 1) {
        openCrewScentPicker({ mode: 'mixed', bundleSize: 1 });
        return;
      }

      var modalApi = window.BadassBundleQtyModal;
      if (!modalApi || typeof modalApi.open !== 'function') {
        openCrewScentPicker({ mode: 'mixed', bundleSize: size });
        return;
      }

      modalApi.open({
        mode: 'pdp',
        quantity: size,
        title: 'Add ' + size + '-candle bundle',
        text: 'Use the same scent for every candle, or pick different scents below.',
        onSame: function () {
          window.setTimeout(function () {
            openCrewScentPicker({ mode: 'same', bundleSize: size });
          }, 0);
          return true;
        },
        onDifferent: function () {
          openCrewScentPicker({ mode: 'mixed', bundleSize: size });
        }
      });
    }

    bundles.forEach(function (card) {
      card.addEventListener('click', function () {
        var prev = activeBundle();
        var prevSize = prev ? parseInt(prev.dataset.size, 10) || 1 : 0;
        bundles.forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');
        var newSize = parseInt(card.dataset.size, 10) || 1;
        if (prevSize !== newSize) {
          lastSyncedSignature = '';
          if (selected.length > newSize) selected.length = newSize;
        }
        setHint('');
        syncSelectedUI();
        syncCta();
        openCrewBundleChoiceModal(newSize);
      });
    });

    if (openPickerBtn) {
      openPickerBtn.addEventListener('click', function () {
        var size = bundleSize();
        if (size <= 1) {
          openCrewScentPicker({ mode: 'mixed', bundleSize: 1 });
        } else if (selected.length >= size) {
          openCrewScentPicker({ mode: 'mixed', bundleSize: size });
        } else {
          openCrewBundleChoiceModal(size);
        }
      });
    }

    /* Mini squad: select = show row, unselect = hide */
    function setMiniOpen(open) {
      if (!miniRow) return;
      miniRow.classList.toggle('is-open', open);
      miniRow.hidden = !open;
      miniRow.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (!open) {
        miniSelected.length = 0;
        syncSelectedUI();
      }
    }

    if (mini) {
      mini.classList.remove('is-selected');
      mini.setAttribute('aria-pressed', 'false');

      mini.addEventListener('click', function () {
        var on = !mini.classList.contains('is-selected');
        mini.classList.toggle('is-selected', on);
        mini.setAttribute('aria-pressed', on ? 'true' : 'false');
        setMiniOpen(on);
        setHint('');
        syncCta();
        maybeOpenSelectionDrawer();
      });

      setMiniOpen(false);
    }

    miniCandles.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!mini || !mini.classList.contains('is-selected')) return;
        /* Single-select: replace any previous mini pick */
        var key = pickKey(btn, 'mini');
        var idx = findByKey(miniSelected, key);
        if (idx > -1) {
          miniSelected.splice(idx, 1);
        } else {
          miniSelected.length = 0;
          miniSelected.push(pickFromBtn(btn, 'mini'));
          var media = parseMedia(btn);
          if (!media.length && btn.dataset.image) {
            media = [{ full: btn.dataset.image, thumb: btn.dataset.image }];
          }
          updateGallery(media, btn.dataset.title || '');
        }
        hideFloatTip();
        setHint('');
        syncSelectedUI();
        syncCta();
        maybeOpenSelectionDrawer();
      });
    });

    /* Accordions + FAQs — always start closed */
    root.querySelectorAll('[data-crew-accordion], [data-crew-faq]').forEach(function (el) {
      el.classList.remove('is-open');
    });

    root.querySelectorAll('[data-crew-accordion-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var box = btn.closest('[data-crew-accordion]');
        if (box) box.classList.toggle('is-open');
      });
    });

    root.querySelectorAll('[data-crew-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-crew-faq]');
        if (!item) return;
        var faqsRoot = item.closest('[data-crew-faqs]') || root;
        var willOpen = !item.classList.contains('is-open');

        /* Only one FAQ open at a time */
        faqsRoot.querySelectorAll('[data-crew-faq].is-open').forEach(function (openItem) {
          if (openItem === item) return;
          openItem.classList.remove('is-open');
          var openBtn = openItem.querySelector('[data-crew-faq-toggle]');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        });

        item.classList.toggle('is-open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    if (selectedList) {
      selectedList.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-crew-chip-peek]');
        if (!btn || !selectedList.contains(btn)) return;
        var idx = parseInt(btn.getAttribute('data-crew-chip-peek'), 10);
        if (isNaN(idx) || !selected[idx]) return;
        openPeek(selected[idx]);
      });
    }

    if (peek) {
      peek.querySelectorAll('[data-crew-peek-close]').forEach(function (el) {
        el.addEventListener('click', closePeek);
      });
      if (peekThumbs) {
        peekThumbs.addEventListener('click', function (e) {
          var thumb = e.target.closest('.badass-crew__peek-thumb');
          if (!thumb || !peekThumbs.contains(thumb)) return;
          var full = thumb.getAttribute('data-full');
          if (full && peekImg) peekImg.src = full;
          peekThumbs.querySelectorAll('.badass-crew__peek-thumb').forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && peek && !peek.hidden) closePeek();
      });
    }

    function scrollToCrewSelect() {
      var target = selectHead || root.querySelector('[data-crew-row]') || root.querySelector('.badass-crew__bundles') || root;
      var headerOffset = 90;
      try {
        var stickyHeader = document.querySelector('.shopify-section-header-sticky, sticky-header, .header-wrapper');
        if (stickyHeader) headerOffset = Math.max(headerOffset, stickyHeader.getBoundingClientRect().height + 12);
      } catch (e) {}
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      if (target.classList) {
        target.classList.add('is-highlight');
        setTimeout(function () {
          target.classList.remove('is-highlight');
        }, 1400);
      }
    }

    function updateStickyCtaVisibility() {
      if (!ctaBar) return;
      var rect = root.getBoundingClientRect();
      /* Show once user reaches the section; keep until they scroll back above it */
      var show = rect.top <= 120;
      ctaBar.classList.toggle('is-visible', show);
      root.classList.toggle('is-cta-sticky', show);
    }

    updateStickyCtaVisibility();
    window.addEventListener('scroll', updateStickyCtaVisibility, { passive: true });
    window.addEventListener('resize', updateStickyCtaVisibility);

    /* ATC — same as Badass Bundle Builder: one pack product + Scent 1…N properties */
    var bundleConfig = readBundleConfig(root);
    var drawerRoot = root.querySelector('[data-bcc-drawer]');
    var drawerDismissed = false;
    var drawerEnabled = root.dataset.enableDrawer !== 'false';
    var drawerSyncTimer = null;
    var crewManagedKeys = [];
    var lastSyncedSignature = '';
    var selectionWasComplete = false;
    var shellIdCache = {};
    var cartBusyDepth = 0;
    var cartOpQueue = Promise.resolve();

    function setDrawerBusy(delta) {
      if (delta) cartBusyDepth += delta;
      else cartBusyDepth = 0;
      if (cartBusyDepth < 0) cartBusyDepth = 0;
      var busy = cartBusyDepth > 0;
      if (drawerRoot) drawerRoot.classList.toggle('is-busy', busy);
      if (window.BadassCrewCartDrawer && window.BadassCrewCartDrawer.setBusy) {
        window.BadassCrewCartDrawer.setBusy(busy);
      }
    }

    function runCartOp(fn) {
      setDrawerBusy(1);
      var op = cartOpQueue.then(
        function () {
          return Promise.resolve().then(fn);
        },
        function () {
          return Promise.resolve().then(fn);
        }
      );
      cartOpQueue = op.then(
        function () {},
        function () {}
      );
      return op.finally(function () {
        setDrawerBusy(-1);
      });
    }

    function updateCrewManagedKeysFromCart(cart, items) {
      crewManagedKeys = [];
      (cart.items || []).forEach(function (line) {
        if (items.some(function (item) { return cartLineMatchesPlannedItem(line, item); })) {
          crewManagedKeys.push(line.key);
        }
      });
    }

    function resolveShellId(size) {
      var key = String(size);
      if (shellIdCache[key]) return Promise.resolve(shellIdCache[key]);
      return resolveBundleVariant(root, size, bundleConfig, moneyFormat).then(function (id) {
        if (id) shellIdCache[key] = String(id);
        return id;
      });
    }

    function isSelectionComplete() {
      var size = bundleSize();
      if (selected.length !== size) return false;
      var miniOn = mini && mini.classList.contains('is-selected');
      if (miniOn && miniSelected.length !== 1) return false;
      return true;
    }

    function buildSelectionCartItems() {
      var b = activeBundle();
      if (!b) return Promise.reject(new Error('Choose a bundle to continue.'));

      var size = parseInt(b.dataset.size, 10) || 1;
      var picks = selected.slice(0, size);
      var bundleLabel = getBundleLabel(b, size, bundleConfig);

      if (picks.length < size) {
        return Promise.reject(new Error('Select ' + size + ' candle' + (size > 1 ? 's' : '') + ' to continue.'));
      }

      var miniOn = mini && mini.classList.contains('is-selected');
      if (miniOn && miniSelected.length < 1) {
        return Promise.reject(new Error('Select 1 mini scent for Mini Squad.'));
      }

      return resolveShellId(size).then(function (shellId) {
        if (!shellId && size <= 1 && picks[0] && picks[0].variantId) {
          shellId = String(picks[0].variantId);
        }
        if (!shellId) {
          throw new Error(
            'This bundle is temporarily unavailable. Assign the same pack product used in the Bundle Builder.'
          );
        }

        var items = [
          {
            id: parseInt(shellId, 10),
            quantity: 1,
            properties: buildBundleProperties(size, bundleLabel, picks, b.dataset.compare, b.dataset.price)
          }
        ];

        if (miniOn && mini.dataset.variantId) {
          var miniTitleEl = mini.querySelector('.badass-crew__mini-title');
          var miniLabel = miniTitleEl ? miniTitleEl.textContent.trim() : 'Mini Scent Squad';
          items.push({
            id: parseInt(mini.dataset.variantId, 10),
            quantity: 1,
            properties: buildBundleProperties(
              miniSize() || miniSelected.length || 1,
              miniLabel,
              miniSelected,
              mini.dataset.compare,
              mini.dataset.price
            )
          });
        }

        return items;
      });
    }

    function syncSelectionToCart(preparedItems) {
      var build = preparedItems ? Promise.resolve(preparedItems) : buildSelectionCartItems();
      return build.then(function (items) {
        var sig = selectionSignature(items);
        if (sig === lastSyncedSignature && cartCache) {
          return cartCache;
        }

        /* Only replace same-size lines from this session — keep other bundles (e.g. Buy 3 + Buy 4) */
        var newSizeKeys = {};
        items.forEach(function (item) {
          newSizeKeys[crewLineSizeKey(item.properties)] = true;
        });

        var updates = {};
        crewManagedKeys.forEach(function (key) {
          var line = findCachedCartLine(key);
          if (!line) {
            updates[key] = 0;
            return;
          }
          var sizeKey = crewLineSizeKey(line.properties);
          if (newSizeKeys[sizeKey]) updates[key] = 0;
        });

        var removePromise =
          Object.keys(updates).length > 0
            ? updateCartLines(updates)
            : fetchCartJson(true);

        return removePromise.then(function (cartAfterRemove) {
          if (!cartAfterRemove || !cartAfterRemove.items) {
            cartAfterRemove = cartCache;
          }
          var currentItems = (cartAfterRemove && cartAfterRemove.items) || [];
          var toAdd = items.filter(function (item) {
            return !currentItems.some(function (line) {
              return cartLineMatchesPlannedItem(line, item);
            });
          });

          if (!toAdd.length) {
            updateCrewManagedKeysFromCart(cartAfterRemove || { items: [] }, items);
            lastSyncedSignature = sig;
            return cartAfterRemove || fetchCartJson(true);
          }

          return addCartItems(toAdd).then(function (freshCart) {
            updateCrewManagedKeysFromCart(freshCart, items);
            lastSyncedSignature = sig;
            return freshCart;
          });
        });
      });
    }

    function loadCrewManagedKeysFromCart() {
      /* Do not mark existing cart lines for auto-removal — user keeps them until manual remove */
      return fetchCartJson(true).then(function (cart) {
        crewManagedKeys = [];
        return cart;
      });
    }

    function revertCrewCartIfIncomplete() {
      if (isSelectionComplete() || !crewManagedKeys.length) return Promise.resolve();
      var updates = {};
      crewManagedKeys.forEach(function (key) {
        updates[key] = 0;
      });
      crewManagedKeys = [];
      lastSyncedSignature = '';
      return updateCartLines(updates);
    }

    function lineMatchesCurrentSelection(item) {
      if (!isSelectionComplete() || !item) return false;
      var props = normalizeCartProperties(item.properties);
      if (!isCartBundleLine(item)) return false;
      if (/mini/i.test(props['Bundle Label'] || '')) {
        return miniSelected.length > 0 && miniSelected[0].title === props['Scent 1'];
      }
      var size = bundleSize();
      if (parseInt(props['Bundle Size'], 10) !== size) return false;
      var i;
      for (i = 0; i < size; i++) {
        if (!selected[i] || selected[i].title !== props['Scent ' + (i + 1)]) return false;
      }
      return true;
    }

    function lineCompareCents(item) {
      if (!item) return 0;
      var props = normalizeCartProperties(item.properties);
      var qty = Math.max(1, parseInt(item.quantity, 10) || 1);
      var retailProp = parseInt(props['_Retail Total'], 10) || 0;
      if (retailProp > 0) return retailProp * qty;

      if (item.original_line_price && item.original_line_price > item.final_line_price) {
        return item.original_line_price;
      }
      if (item.original_price && item.final_price && item.original_price > item.final_price) {
        return item.original_price * qty;
      }
      if (item.compare_at_price && item.compare_at_price > (item.final_price || item.price || 0)) {
        return item.compare_at_price * qty;
      }
      return 0;
    }

    function findScentImageByTitle(title) {
      var needle = String(title || '')
        .toLowerCase()
        .trim();
      if (!needle) return '';
      var i;
      for (i = 0; i < selected.length; i++) {
        if (selected[i] && String(selected[i].title || '').toLowerCase().trim() === needle) {
          return selected[i].thumb || selected[i].image || '';
        }
      }
      for (i = 0; i < miniSelected.length; i++) {
        if (miniSelected[i] && String(miniSelected[i].title || '').toLowerCase().trim() === needle) {
          return miniSelected[i].thumb || miniSelected[i].image || '';
        }
      }
      for (i = 0; i < scentCatalog.length; i++) {
        var p = scentCatalog[i];
        if (p && String(p.title || '').toLowerCase().trim() === needle) {
          return p.thumb || p.featured_image || p.image || '';
        }
      }
      return '';
    }

    function cartItemToDrawerLine(item) {
      var props = normalizeCartProperties(item.properties);
      var priceCents = item.final_line_price || item.line_price || 0;
      var compareCents = lineCompareCents(item);
      if (compareCents <= priceCents) compareCents = 0;
      var canEditScents = lineMatchesCurrentSelection(item);

      if (isCartBundleLine(item)) {
        var scents = [];
        var i;
        for (i = 1; i <= 6; i++) {
          var scentName = props['Scent ' + i];
          if (!scentName) continue;
          var scentImg =
            props['_Scent ' + i + ' Image'] || findScentImageByTitle(scentName) || '';
          scents.push({ title: scentName, index: i, image: scentImg });
        }
        var label = props['Bundle Label'] || item.product_title || 'Custom Bundle';
        var isMini = /mini/i.test(label);
        var bundleSizeNum = parseInt(props['Bundle Size'], 10) || scents.length;
        var lineImage =
          (scents[0] && scents[0].image) ||
          props['_Scent 1 Image'] ||
          findScentImageByTitle(scents[0] && scents[0].title) ||
          item.image;
        return {
          type: 'bundle',
          key: item.key,
          tag: isMini ? 'Mini Squad' : 'Buy ' + bundleSizeNum,
          title: label,
          priceCents: priceCents,
          compareCents: compareCents,
          quantity: item.quantity,
          image: lineImage,
          scents: scents,
          canEditScents: !!canEditScents
        };
      }

      return {
        type: 'item',
        key: item.key,
        title: item.product_title,
        variantTitle: item.variant_title,
        priceCents: priceCents,
        compareCents: compareCents,
        quantity: item.quantity,
        image: item.image
      };
    }

    function buildDrawerStateFromCart(cart) {
      var items = (cart && cart.items) || [];
      var lines = items.map(function (item) {
        return cartItemToDrawerLine(item);
      });
      var compareTotal = 0;
      lines.forEach(function (line) {
        compareTotal +=
          line.compareCents && line.compareCents > line.priceCents
            ? line.compareCents
            : line.priceCents || 0;
      });
      var totalCents = (cart && cart.total_price) || 0;

      return {
        lines: lines,
        totalCents: totalCents,
        compareCents: compareTotal > totalCents ? compareTotal : 0
      };
    }

    function refreshDrawerFromCart(cart, options) {
      if (!drawerRoot || !window.BadassCrewCartDrawer) return Promise.resolve(cart);
      var force = !!(options && options.force);
      var load;
      if (force) {
        invalidateCartCache();
        load = fetchCartJson(true);
      } else if (cart && Array.isArray(cart.items)) {
        load = Promise.resolve(setCartCache(cart));
      } else {
        load = fetchCartJson(true);
      }
      return load.then(function (cartState) {
        if (!cartState || !Array.isArray(cartState.items)) {
          return fetchCartJson(true).then(function (fresh) {
            window.BadassCrewCartDrawer.render(buildDrawerStateFromCart(fresh || { items: [], total_price: 0 }));
            return fresh;
          });
        }
        window.BadassCrewCartDrawer.render(buildDrawerStateFromCart(cartState));
        return cartState;
      });
    }

    function findCachedCartLine(lineKey) {
      if (!cartCache || !cartCache.items) return null;
      for (var i = 0; i < cartCache.items.length; i++) {
        if (cartCache.items[i].key === lineKey) return cartCache.items[i];
      }
      return null;
    }

    function clearSelectionForCartLine(line) {
      if (!line || !lineMatchesCurrentSelection(line)) return;
      var props = normalizeCartProperties(line.properties);
      if (/mini/i.test(props['Bundle Label'] || '')) {
        miniSelected.length = 0;
        return;
      }
      selected.length = 0;
    }

    function removeScentFromSelection(scentTitle, isMiniLine) {
      var list = isMiniLine ? miniSelected : selected;
      var idx = -1;
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i].title === scentTitle) {
          idx = i;
          break;
        }
      }
      if (idx > -1) list.splice(idx, 1);
    }

    function maybeOpenSelectionDrawer() {
      if (!drawerEnabled || !drawerRoot || !window.BadassCrewCartDrawer) return;

      if (drawerSyncTimer) window.clearTimeout(drawerSyncTimer);

      var complete = isSelectionComplete();

      if (!complete) {
        drawerDismissed = false;
        if (selectionWasComplete) {
          runCartOp(function () {
            return revertCrewCartIfIncomplete().then(function () {
              if (window.BadassCrewCartDrawer.isOpen()) {
                return refreshDrawerFromCart(null, { force: true });
              }
            });
          }).catch(function () {});
        }
        selectionWasComplete = false;
        /* Do not auto-close — mobile remove/qty was closing the drawer mid-update. */
        return;
      }

      selectionWasComplete = true;

      drawerSyncTimer = window.setTimeout(function () {
        if (!drawerDismissed && window.BadassCrewCartDrawer && !window.BadassCrewCartDrawer.isOpen()) {
          window.BadassCrewCartDrawer.open();
        }
        if (cartCache) refreshDrawerFromCart(cartCache);

        runCartOp(function () {
          return buildSelectionCartItems().then(function (items) {
            var sig = selectionSignature(items);
            if (sig === lastSyncedSignature && cartCache) {
              return refreshDrawerFromCart(cartCache, { force: true });
            }
            return syncSelectionToCart(items).then(function () {
              return refreshDrawerFromCart(null, { force: true });
            });
          });
        }).catch(function (err) {
          setDrawerBusy(0);
          if (err && err.message) setHint(err.message);
        });
      }, 120);
    }

    function bootSelectionDrawer() {
      if (!drawerEnabled || !drawerRoot || !window.BadassCrewCartDrawer) return;
      var freeShip = parseInt(drawerRoot.getAttribute('data-free-shipping'), 10) || 0;
      window.BadassCrewCartDrawer.init(drawerRoot, {
        moneyFormat: moneyFormat,
        freeShippingThreshold: freeShip,
        onClose: function () {
          if (isSelectionComplete()) drawerDismissed = true;
        },
        callbacks: {
          onChangeQuantity: function (lineKey, quantity) {
            var qty = Math.max(0, parseInt(quantity, 10) || 0);
            if (window.BadassCrewCartDrawer && window.BadassCrewCartDrawer.suppressOverlayClose) {
              window.BadassCrewCartDrawer.suppressOverlayClose(600);
            }
            if (qty < 1) {
              return runCartOp(function () {
                var line = findCachedCartLine(lineKey);
                return updateCartLines(
                  (function () {
                    var u = {};
                    u[lineKey] = 0;
                    return u;
                  })()
                ).then(function () {
                  if (line) {
                    clearSelectionForCartLine(line);
                    var idx = crewManagedKeys.indexOf(lineKey);
                    if (idx > -1) crewManagedKeys.splice(idx, 1);
                    lastSyncedSignature = '';
                  }
                  selectionWasComplete = isSelectionComplete();
                  syncSelectedUI();
                  syncCta();
                  syncProductPreview();
                  return refreshDrawerFromCart(null, { force: true });
                });
              }).catch(function () {
                setHint('Could not update quantity.');
              });
            }
            runCartOp(function () {
              var updates = {};
              updates[lineKey] = qty;
              return updateCartLines(updates).then(function () {
                return refreshDrawerFromCart(null, { force: true });
              });
            }).catch(function () {
              setHint('Could not update quantity.');
            });
          },
          onRemoveLine: function (lineKey) {
            if (window.BadassCrewCartDrawer && window.BadassCrewCartDrawer.suppressOverlayClose) {
              window.BadassCrewCartDrawer.suppressOverlayClose(600);
            }
            runCartOp(function () {
              var line = findCachedCartLine(lineKey);
              var updates = {};
              updates[lineKey] = 0;
              return updateCartLines(updates).then(function () {
                if (line) {
                  clearSelectionForCartLine(line);
                  var idx = crewManagedKeys.indexOf(lineKey);
                  if (idx > -1) crewManagedKeys.splice(idx, 1);
                  lastSyncedSignature = '';
                }
                selectionWasComplete = isSelectionComplete();
                syncSelectedUI();
                syncCta();
                syncProductPreview();
                return refreshDrawerFromCart(null, { force: true });
              });
            }).catch(function () {
              setHint('Could not remove item. Please try again.');
            });
          },
          onRemoveScent: function (lineKey, scentIndex) {
            if (window.BadassCrewCartDrawer && window.BadassCrewCartDrawer.suppressOverlayClose) {
              window.BadassCrewCartDrawer.suppressOverlayClose(600);
            }
            runCartOp(function () {
              var line = findCachedCartLine(lineKey);
              if (!line) return refreshDrawerFromCart(null, { force: true });
              var props = normalizeCartProperties(line.properties);
              var scentTitle = props['Scent ' + scentIndex];
              if (!scentTitle) return refreshDrawerFromCart(null, { force: true });
              var isMiniLine = /mini/i.test(props['Bundle Label'] || '');
              removeScentFromSelection(scentTitle, isMiniLine);
              lastSyncedSignature = '';
              selectionWasComplete = isSelectionComplete();
              syncSelectedUI();
              syncCta();
              syncProductPreview();
              if (!isSelectionComplete()) {
                return revertCrewCartIfIncomplete().then(function () {
                  return refreshDrawerFromCart(null, { force: true });
                });
              }
              return syncSelectionToCart().then(function () {
                return refreshDrawerFromCart(null, { force: true });
              });
            }).catch(function () {
              setHint('Could not update your selection. Please try again.');
            });
          },
          onCheckout: function () {
            setCtasDisabled(true);
            runCartOp(function () {
              return syncSelectionToCart();
            })
              .then(function () {
                window.location.href = checkoutUrl();
              })
              .catch(function (err) {
                setCtasDisabled(false);
                setHint((err && err.message) || 'Could not continue to checkout.');
              });
          },
          onUpsellAdd: function (variantId) {
            if (!variantId) return;
            runCartOp(function () {
              return addCartItems([{ id: variantId, quantity: 1 }]).then(function () {
                return refreshDrawerFromCart(null, { force: true });
              });
            }).catch(function () {
              setHint('Could not add item to cart.');
            });
          }
        }
      });
      loadCrewManagedKeysFromCart().catch(function () {});
      [1, 3, 4, 6].forEach(function (sz) {
        resolveShellId(sz).catch(function () {});
      });
    }

    if (drawerRoot) {
      if (window.BadassCrewCartDrawer) bootSelectionDrawer();
      else window.addEventListener('load', bootSelectionDrawer);
    }

    function handleCtaClick(goToCheckoutOverride) {
      var goToCheckout =
        goToCheckoutOverride != null ? !!goToCheckoutOverride : /checkout/i.test(ctaLabel);

      setCtasDisabled(true);
      setHint('');

      buildSelectionCartItems()
        .then(function () {
          return runCartOp(function () {
            return syncSelectionToCart();
          });
        })
        .then(function () {
          window.location.href = goToCheckout ? checkoutUrl() : cartPageUrl();
        })
        .catch(function (err) {
          setCtasDisabled(false);
          var msg = (err && err.message) || 'Could not add to cart. Please try again.';
          setHint(msg);
          if (msg.indexOf('Select ') === 0 || msg.indexOf('Choose ') === 0) {
            scrollToCrewSelect();
          }
          if (msg.indexOf('mini') > -1 && miniRow) {
            miniRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
    }

    ctas.forEach(function (btn) {
      btn.addEventListener('click', handleCtaClick);
    });

    syncSelectedUI();
    syncCta();
    syncPackPricesFromShopify(root, moneyFormat).then(function () {
      syncCta();
    });
  }

  function scheduleCrewInit(fn) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(function () { fn(); }, { timeout: 2500 });
    } else {
      window.setTimeout(fn, 1);
    }
  }

  function boot() {
    document.querySelectorAll('[data-badass-crew]').forEach(function (el) {
      function run() {
        init(el);
      }
      if (!el.dataset.crewInteractBound) {
        el.dataset.crewInteractBound = '1';
        var flush = function () {
          run();
        };
        el.addEventListener('pointerdown', flush, { capture: true, once: true });
        el.addEventListener('keydown', flush, { capture: true, once: true });
        el.addEventListener('focusin', flush, { capture: true, once: true });
      }
      scheduleCrewInit(run);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-badass-crew]').forEach(function (el) {
      delete el.dataset.crewReady;
      init(el);
    });
  });
})();
